export default "__VITE_ASSET__Bzkf7Is9__"